import React from 'react';

const STATUSES = ['todo', 'doing', 'blocked', 'done'];

const TasksTab = ({
  project,
  showTaskForm,
  newTask,
  onShowTaskForm,
  onHideTaskForm,
  onNewTaskChange,
  onCreateTask,
  onUpdateTaskStatus,
}) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Project Tasks</h3>
        <button
          onClick={onShowTaskForm}
          className="px-4 py-2 bg-blue-600 dark:bg-blue-700 text-white rounded-md hover:bg-blue-700 dark:hover:bg-blue-800"
        >
          Add Task
        </button>
      </div>

      {/* Task Creation Form */}
      {showTaskForm && (
        <form
          onSubmit={onCreateTask}
          className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <input
              type="text"
              placeholder="Task title"
              value={newTask.title}
              onChange={(e) => onNewTaskChange({ ...newTask, title: e.target.value })}
              className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
              required
            />
            <input
              type="date"
              value={newTask.due_date}
              onChange={(e) => onNewTaskChange({ ...newTask, due_date: e.target.value })}
              className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            />
            <input
              type="text"
              placeholder="Notes"
              value={newTask.notes}
              onChange={(e) => onNewTaskChange({ ...newTask, notes: e.target.value })}
              className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
            />
          </div>
          <div className="flex gap-2">
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 dark:bg-green-700 text-white rounded-md hover:bg-green-700 dark:hover:bg-green-800"
            >
              Create Task
            </button>
            <button
              type="button"
              onClick={onHideTaskForm}
              className="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-md hover:bg-gray-400 dark:hover:bg-gray-500"
            >
              Cancel
            </button>
          </div>
        </form>
      )}

      {/* Tasks List */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {STATUSES.map((status) => (
          <div
            key={status}
            className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700"
          >
            <h4 className="font-medium mb-3 capitalize text-gray-900 dark:text-white">{status}</h4>
            <div className="space-y-2">
              {(project.project_tasks || [])
                .filter((task) => task.status === status)
                .map((task) => (
                  <div
                    key={task.id}
                    className="bg-white dark:bg-gray-700 p-3 rounded border border-gray-200 dark:border-gray-600 shadow-sm"
                  >
                    <div className="font-medium text-sm text-gray-900 dark:text-white">{task.title}</div>
                    {task.due_date && (
                      <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">Due: {task.due_date}</div>
                    )}
                    {task.notes && (
                      <div className="text-xs text-gray-600 dark:text-gray-300 mt-1">{task.notes}</div>
                    )}
                    <div className="mt-2 flex gap-1 flex-wrap">
                      {STATUSES.map((newStatus) =>
                        newStatus !== status ? (
                          <button
                            key={newStatus}
                            onClick={() => onUpdateTaskStatus(task.id, newStatus)}
                            className="text-xs px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded hover:bg-blue-200 dark:hover:bg-blue-800"
                          >
                            → {newStatus}
                          </button>
                        ) : null,
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TasksTab;


